var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 6.16927V4.5026C1.66667 2.20142 3.53215 0.335938 5.83333 0.335938C8.13452 0.335938 10 2.20142 10 4.5026V6.16927C10.9205 6.16927 11.6667 6.91546 11.6667 7.83594V12.0026C11.6667 12.9231 10.9205 13.6693 10 13.6693H1.66667C0.746192 13.6693 0 12.9231 0 12.0026V7.83594C0 6.91546 0.746192 6.16927 1.66667 6.16927ZM8.33333 4.5026V6.16927H3.33333V4.5026C3.33333 3.12189 4.45262 2.0026 5.83333 2.0026C7.21405 2.0026 8.33333 3.12189 8.33333 4.5026Z",
    fill: "#89A037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLock);
export default __webpack_public_path__ + "static/media/green-lock.37e66f9f81ca1bd48eb7a0193d02a719.svg";
export { ForwardRef as ReactComponent };